import React from "react";
import { useSelector } from "react-redux";
import { Result, Button } from "antd";
import Loading from "../../Loading/Loading";
import warningImage from "../../../images/alert-sign.png";
import { t } from "i18next";

const ExpireSuccessTickets = () => {
  const { sendTicketPaymentLoading } = useSelector(
    (state) => state.ticketReducer
  );

  return sendTicketPaymentLoading === true ? (
    <Loading />
  ) : (
    <div className="expire-success-payment-container">
      <Result
        icon={
          <img
            className="empty-favorite-destination-image"
            src={warningImage}
            alt="noSchedule"
          />
        }
        title={t("resultsNotFound")}
        subTitle={
          <p style={{ fontSize: "18px" }}>{t("pleaseCheckYourEmail")}</p>
        }
        extra={[
          <a href="/order-history" key="2">
            <Button
              size="large"
              type="primary"
              className="custom-button expire-ticket-payment-result-back-button"
            >
              {t("orderHistory")}
            </Button>
          </a>,
        ]}
      />
    </div>
  );
};

export default ExpireSuccessTickets;
